#import "@/components/common/LinkFragment.gql"

fragment SmallTopicFeatureFragment on smallTopicFeature_Entry {
  typeHandle
  heading
  cta {
    ...LinkFragment
  }
  smallTopicFeatureTopics: topicCards {
    ... on topicCardsBlock_Entry {
      heading
      image {
        url
        title
      }
      alt
      topic {
        ...LinkFragment
      }
    }
  }
}
